import { builder } from './index';

interface BuildRequestBase {
  contentType?: string | null;
  scrapeProbabilityScore?: boolean;
  withCookies?: boolean;
}

export const buildGetRequest = (options?: BuildRequestBase): RequestInit =>
  builder()
    .method('GET')
    .content(null, options?.contentType)
    .scrapeProbabilityScore(options?.scrapeProbabilityScore)
    .build();

export const buildPostRequest = (content?: any, contentType?: string | null): RequestInit =>
  builder().method('POST').content(content, contentType).build();

export const buildAuthorizedGetRequest = (token: string, options?: BuildRequestBase): RequestInit =>
  builder().method('GET').content(null, options?.contentType).token(token).build();

type BuildPostRequest = BuildRequestBase & {
  content: any;
};

export const buildAuthorizedPostRequest = (token: string, options: BuildPostRequest): RequestInit =>
  builder().method('POST').content(options.content, options.contentType).token(token).build();

type BuildPutRequest = BuildPostRequest;

export const buildAuthorizedPutRequest = (token: string, options: BuildPutRequest): RequestInit =>
  builder().method('PUT').content(options.content).token(token).build();

export const buildAuthorizedDeleteRequest = (token: string): RequestInit =>
  builder().method('DELETE').token(token).build();

type BuildPostFormRequest = BuildPostRequest;

export const buildAuthorizedFormPostRequest = (
  token: string,
  options: BuildPostFormRequest,
): RequestInit => builder().method('POST').content(options.content, null).token(token).build();
